export async function restRequest(url, method, body, token) {
  const rawResponse = await fetch(url, {
    headers: Object.assign(
      { Accept: 'application/json', 'Content-Type': 'application/json' },
      token && { Authorization: 'Bearer ' + token },
    ),
    method,
    body: JSON.stringify(body),
  });
  if (!rawResponse.ok) {
    throw Error('bad response');
  }
  const response = await rawResponse.json();
  return response;
}
//# sourceMappingURL=rest.js.map
